import Columns from '../../grid/columns';
import { debounce } from 'lodash';
import ExpandButtons from '../../extensions/expandButtons';

export default instance => {
  instance.attachEvent('onDataRender', debounce(() => Columns.onDataRender(), 200));

  instance.attachEvent('onDataRender', () => {
    if (instance.ganttDataApi.isBase() || instance.ganttDataApi.isHistory()) {
      ExpandButtons.debouncedUpdatePositions();
    }
  });
};
